@let config = tabsConfig();

@if (config) {
  @if (config.showHeader) {
    @if (isLoading()) {
      <div class="skeletons">
        @for (skeleton of skeletons(); track skeleton) {
          <mds-skeleton-loader [width]="'6rem'" [height]="'1.75rem'" />
        }
      </div>
    } @else {
      <mds-tab-header
        [disabled]="!!config.disabled"
        [tabs]="tabs"
        [size]="config.size ?? TabSize.Small"
        (handleClick)="selectTab($event)"
      />
    }
  }
  <ng-content />
}
